import axios from '../plugins/axios'

// XAN-143 — digital report (Análisis de Idoneidad) filled online per process.
const getDigitalReport = (processId) => axios.get(`/digital-report/process/${processId}`)
const saveDigitalReportSection = (processId, sectionKey, answers, completed) =>
  axios.put(`/digital-report/process/${processId}/section/${sectionKey}`, { answers, completed }, { skipLoading: true })
const previewDigitalReport = (processId) =>
  axios.get(`/digital-report/process/${processId}/preview`, { responseType: 'blob' })
const generateDigitalReport = (processId) => axios.post(`/digital-report/process/${processId}/pdf`)
const getDigitalReportFile = (processId, version) => axios.get(`/digital-report/process/${processId}/pdf/${version}`)
const getPreviousReportSection = (processId, sectionKey, sourceProcessId) =>
  axios.get(`/digital-report/process/${processId}/section/${sectionKey}/previous/${sourceProcessId}`, { skipLoading: true })
const importProcessFileToReport = (processId, fileId) =>
  axios.post(`/digital-report/process/${processId}/import-file`, { fileId })

export {
  getDigitalReport,
  saveDigitalReportSection,
  previewDigitalReport,
  generateDigitalReport,
  getDigitalReportFile,
  getPreviousReportSection,
  importProcessFileToReport
}
